import { render, staticRenderFns } from "./CategoryOption.vue?vue&type=template&id=4f77f742&"
import script from "./CategoryOption.vue?vue&type=script&lang=js&"
export * from "./CategoryOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports